<form [formGroup]="form">
  <div class="row">
    <div class="form-group" [ngClass]="isTemplate ? 'col-md-12' : 'col-md-6'">
      <label>{{ 'dataconnection.name' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.name"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group" *ngIf="!isTemplate">
      <label>{{ 'dataconnection.identifier' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.identifier"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'dataconnection.description' | translate }}</label>
      <app-input-with-error
        inputType="textarea"
        rows="1"
        [control]="form.controls.description"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'dataconnection.url' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.url"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'dataconnection.authentication' | translate }}</label>
      <app-input-with-error
        [inputType]="'select'"
        [selectValues]="authenticationValues"
        [translateSelect]="false"
        [control]="form.controls.configuration.controls.authentication"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'dataconnection.jobListEndpoint' | translate }}</label>
      <app-input-with-error
        [inputType]="'select'"
        [translateSelect]="false"
        [selectDefaultText]="'dataconnection.jobListEndpoint_none' | translate"
        [selectValues]="[''].concat(getEndpointIdentifiers())"
        [selectNames]="
          ['dataconnection.jobListEndpoint_none' | translate].concat(
            getEndpointIdentifiers()
          )
        "
        [control]="form.controls.configuration.controls.jobListEndpoint"
        helpText="{{ 'dataconnection.jobListEndpoint_help' | translate }}"
      ></app-input-with-error>
    </div>
    <div
      *ngIf="
        form.controls.configuration.controls.authentication.value ===
        HttpAuthentication.BASIC
      "
      class="col-md-6 form-group"
    >
      <label>{{ 'dataconnection.username' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.username"
      ></app-input-with-error>
    </div>
    <div
      *ngIf="
        form.controls.configuration.controls.authentication.value ===
          HttpAuthentication.BASIC && !isTemplate
      "
      class="col-md-6 form-group"
    >
      <label>{{ 'dataconnection.password' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.password"
      ></app-input-with-error>
    </div>
    <div
      *ngIf="
        form.controls.configuration.controls.authentication.value ===
          HttpAuthentication.BEARER && !isTemplate
      "
      class="col-md-12 form-group"
    >
      <label>{{ 'dataconnection.token' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.token"
      ></app-input-with-error>
    </div>
    <div
      *ngIf="
        form.controls.configuration.controls.authentication.value ===
          HttpAuthentication.OAUTH_CLIENT_CREDENTIALS ||
        form.controls.configuration.controls.authentication.value ===
          HttpAuthentication.OAUTH_CLIENT_CREDENTIALS_BASIC_AUTH
      "
      class="col-md-12 form-group"
    >
      <label>{{ 'dataconnection.tokenUrl' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.tokenUrl"
      ></app-input-with-error>
      @if (!isTemplate) {
        <label>{{ 'dataconnection.clientId' | translate }}</label>
        <app-input-with-error
          [control]="form.controls.configuration.controls.clientId"
        ></app-input-with-error>
        <label>{{ 'dataconnection.clientSecret' | translate }}</label>
        <app-input-with-error
          [control]="form.controls.configuration.controls.clientSecret"
        ></app-input-with-error>
      }
      <label>{{ 'dataconnection.scope' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.scope"
      ></app-input-with-error>
    </div>
    <div class="col-md-3 form-group mb-2" style="margin-top: 2.5rem">
      <app-input-with-error
        [control]="this.form.controls.configuration.controls.useXSRFToken"
        [inputType]="'checkbox'"
        description="dataconnection.useXSRFToken"
      ></app-input-with-error>
      <div class="form-text mt-0">
        {{ 'dataconnection.useXSRFToken?' | translate }}
      </div>
    </div>
    <div
      *ngIf="form.controls.configuration.controls.useXSRFToken.value === true"
      class="col-md-6 form-group mt-3 mb-3"
    >
      <label>{{ 'dataconnection.xsrfTokenHeader' | translate }}</label>
      <app-input-with-error
        [control]="form.controls.configuration.controls.xsrfTokenHeader"
      ></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <h5 class="mt-3">
        <span>{{ 'dataconnection.endpoints' | translate }}</span>
        <div
          class="btn btn-sm btn-outline-success p-0 ms-2"
          (click)="addEndpoint()"
        >
          <span class="material-icons-outlined">add</span>
        </div>
      </h5>
      <ng-container formArrayName="endpoints">
        @for (
          endpointForm of this.form.controls.endpoints.controls;
          track $index
        ) {
          <div class="entity-group">
            <button
              type="button"
              class="btn-remove"
              (click)="deleteEndpoint($index)"
              aria-label="Close"
              data-bs-toggle="tooltip"
              title="{{ 'delete' | translate }}"
            >
              <span class="material-symbols-outlined">close</span>
            </button>
            <div [formGroup]="endpointForm" class="row">
              <div class="col-md-6 form-group">
                <label>{{
                  'dataconnection.endpoint.identifier' | translate
                }}</label>
                <app-input-with-error
                  [control]="endpointForm.controls.identifier"
                ></app-input-with-error>
              </div>
              <div class="col-md-6 form-group">
                <label>{{
                  'dataconnection.endpoint.method' | translate
                }}</label>
                <app-input-with-error
                  [inputType]="'select'"
                  [selectValues]="methodValues"
                  [translateSelect]="false"
                  [control]="endpointForm.controls.method"
                ></app-input-with-error>
              </div>
              <div class="col-md-12 form-group">
                <label>{{ 'dataconnection.endpoint.url' | translate }}</label>
                <app-input-with-error
                  [control]="endpointForm.controls.url"
                ></app-input-with-error>
              </div>
              <div class="col-md-12 form-group mb-2">
                <app-input-with-error
                  [control]="endpointForm.controls.isLocal"
                  [inputType]="'checkbox'"
                  description="dataconnection.endpoint.isLocal"
                ></app-input-with-error>
                <div class="form-text mt-0">
                  {{ 'dataconnection.endpoint.isLocal?' | translate }}
                </div>
              </div>
              <div class="col-md-12 form-group mt-3">
                <div
                  class="btn btn-sm btn-warning me-2 btn-edit"
                  (click)="editBody(endpointForm)"
                >
                  {{ 'dataconnection.endpoint.body' | translate }}
                </div>
                <div
                  class="btn btn-sm btn-warning me-2 btn-edit"
                  (click)="editPreprocess(endpointForm)"
                >
                  {{ 'dataconnection.endpoint.preprocess' | translate }}
                </div>
                <div
                  class="btn btn-sm btn-warning me-2 btn-edit"
                  (click)="editPostprocess(endpointForm)"
                >
                  {{ 'dataconnection.endpoint.postprocess' | translate }}
                </div>
                <div
                  class="btn btn-sm btn-warning me-2 btn-edit"
                  (click)="editHeader(endpointForm)"
                >
                  {{ 'dataconnection.endpoint.header' | translate }}
                </div>
                <div
                  class="btn btn-sm btn-warning me-2 btn-edit"
                  (click)="editQuery(endpointForm)"
                >
                  {{ 'dataconnection.endpoint.query' | translate }}
                </div>
                <div
                  class="btn btn-sm btn-primary me-2"
                  *ngIf="!endpointForm.dirty"
                  (click)="testEndpoint(endpointForm)"
                >
                  {{ 'dataconnection.endpoint.test' | translate }}
                </div>
                <div
                  class="btn btn-sm btn-outline-primary me-2"
                  *ngIf="endpointForm.dirty"
                  (click)="save()"
                >
                  {{ 'save' | translate }}
                </div>
                <div
                  class="form-text mt-2"
                  *ngIf="endpointForm.controls.isLocal.value"
                >
                  {{ 'dataconnection.endpoint.test-cloud-info' | translate }}
                </div>
              </div>
            </div>
          </div>
        }
      </ng-container>
    </div>
  </div>
</form>

<!-- TODO: Use app model modal as a wrapper so we have all modals the same -->
<app-key-value-form #keyValueFormModal></app-key-value-form>
